<footer>
  <img src="assets/img/logoCQ.png" alt="UCQI - Controle de Qualidade" title="UCQI - Controle de Qualidade">
  <img src="assets/img/logo/sgi-rodape.png" alt="SGI - Superintendência de Gestão da Informação" title="SGI - Superintendência de Gestão da Informação">
  <div>
    <img src="assets/img/logo_imasul.png" class="img-imasul" alt="IMASUL - Instituto de Meio Ambiente de Mato Grosso do Sul" title="IMASUL - Instituto de Meio Ambiente de Mato Grosso do Sul">
  </div>
</footer>
